// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-filter {
  display: inline-flex;
  align-items: center;
  margin-left: 2px;
}

.col-filter-btn {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  color: var(--text-muted);
  opacity: 0.25;
  cursor: pointer;
  padding: 0 2px;
  transition: opacity 0.15s;
}

.col-filter-btn:hover,
.th-sortable:hover .col-filter-btn {
  opacity: 0.7;
}

.col-filter-active {
  color: var(--accent-light);
  opacity: 1 !important;
}

.col-filter-popup {
  position: fixed;
  z-index: 1000;
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 6px;
  min-width: 160px;
  max-width: 260px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.col-filter-input {
  width: 100%;
  box-sizing: border-box;
  padding: 4px 6px;
  background: var(--bg-input);
  color: var(--text-primary);
  border: 1px solid var(--border);
  border-radius: 3px;
  font-size: 12px;
  outline: none;
}

.col-filter-input:focus {
  border-color: var(--accent-light);
}

.col-filter-clear {
  margin-top: 4px;
  width: 100%;
  padding: 3px 6px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: 3px;
  font-size: 11px;
  cursor: pointer;
}

.col-filter-clear:hover {
  background: var(--bg-hover);
}

.col-filter-actions {
  display: flex;
  gap: 4px;
  margin: 4px 0;
}

.col-filter-actions button {
  flex: 1;
  padding: 2px 6px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  border-radius: 3px;
  font-size: 11px;
  cursor: pointer;
}

.col-filter-actions button:hover:not(:disabled) {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.col-filter-actions button:disabled {
  opacity: 0.4;
  cursor: default;
}

.col-filter-list {
  max-height: 200px;
  overflow-y: auto;
}

.col-filter-option {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 2px;
  font-size: 12px;
  color: var(--text-primary);
  cursor: pointer;
  border-radius: 2px;
}

.col-filter-option:hover {
  background: var(--bg-hover);
}

.col-filter-option input[type="checkbox"] {
  margin: 0;
  flex-shrink: 0;
}

.col-filter-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.col-filter-empty {
  padding: 8px 4px;
  color: var(--text-muted);
  font-size: 12px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/ColumnFilter.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".col-filter {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 2px;\n}\n\n.col-filter-btn {\n  display: inline-flex;\n  align-items: center;\n  font-size: 10px;\n  color: var(--text-muted);\n  opacity: 0.25;\n  cursor: pointer;\n  padding: 0 2px;\n  transition: opacity 0.15s;\n}\n\n.col-filter-btn:hover,\n.th-sortable:hover .col-filter-btn {\n  opacity: 0.7;\n}\n\n.col-filter-active {\n  color: var(--accent-light);\n  opacity: 1 !important;\n}\n\n.col-filter-popup {\n  position: fixed;\n  z-index: 1000;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 6px;\n  min-width: 160px;\n  max-width: 260px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.col-filter-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 4px 6px;\n  background: var(--bg-input);\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  font-size: 12px;\n  outline: none;\n}\n\n.col-filter-input:focus {\n  border-color: var(--accent-light);\n}\n\n.col-filter-clear {\n  margin-top: 4px;\n  width: 100%;\n  padding: 3px 6px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.col-filter-clear:hover {\n  background: var(--bg-hover);\n}\n\n.col-filter-actions {\n  display: flex;\n  gap: 4px;\n  margin: 4px 0;\n}\n\n.col-filter-actions button {\n  flex: 1;\n  padding: 2px 6px;\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  font-size: 11px;\n  cursor: pointer;\n}\n\n.col-filter-actions button:hover:not(:disabled) {\n  background: var(--bg-hover);\n  color: var(--text-primary);\n}\n\n.col-filter-actions button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.col-filter-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.col-filter-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 2px;\n  font-size: 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n  border-radius: 2px;\n}\n\n.col-filter-option:hover {\n  background: var(--bg-hover);\n}\n\n.col-filter-option input[type=\"checkbox\"] {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.col-filter-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.col-filter-empty {\n  padding: 8px 4px;\n  color: var(--text-muted);\n  font-size: 12px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
